import { betradarProvider, imgProvider, newStreamsProvider, performProvider, performWBProvider } from './services';
import { NikeStream } from '../../types/generated/nike-stream';
import { isEmpty } from 'lodash';
import { nuiCtx } from '../../common/initialization';
import { isProfilePlayerProviderFullscreenEnabled } from '../../profiles';

export const getStreamProvider = provider => {
    switch (provider) {
        case 'IMG':
            return imgProvider;
        case 'PERFORM':
            return performProvider;
        case 'PERFORM_WB':
            return performWBProvider;
        case 'BETRADAR_OLD':
        case 'BETRADAR':
            return betradarProvider;
        default:
            return newStreamsProvider;
    }
};

export const EMBED_STREAM_PROVIDERS: NikeStream.Provider[] = ['YOUTUBE', 'FACEBOOK', 'TWITCH'];
export const isEmbedStreamProvider = provider => EMBED_STREAM_PROVIDERS.includes(provider) && provider !== 'YOUTUBE';

export const STREAM_PLAYER_TYPES = ['HLS', 'EMBED', 'YOUTUBE'] as const;
export type StreamPlayerType = typeof STREAM_PLAYER_TYPES[number];

export const isSupportedStreamPlayerType = (streamPlayerType?: StreamPlayerType) => {
    return STREAM_PLAYER_TYPES.includes(streamPlayerType);
};

export const resolveStreamPlayerType = (provider: NikeStream.Provider | string, src: string): StreamPlayerType => {
    if (isEmpty(provider) || isEmpty(src)) {
        return null;
    }

    if (provider === 'YOUTUBE') {
        return 'YOUTUBE';
    }

    if (isEmbedStreamProvider(provider) || (!src?.includes('.m3u8') && !src?.includes('.mp4'))) {
        return 'EMBED';
    }

    return 'HLS';
};

// ak bude zapnuty profil a niektory provider sa bude stazovat na nerespektovanie pravidiel, doplnime ho do pola NOT_FULLSCREEN_CONDITION_PROVIDER
const NOT_FULLSCREEN_COMPLAINING_PROVIDER = [];
export const allowFullscreenStream = (provider?: NikeStream.Provider | string) => {
    // pre portal je fullscreen dovoleny vzdy iba pre vybranych providerov v poli
    if (nuiCtx.platform !== 'mobile') return ['HUSTETV', 'VHSTREAM', 'YOUTUBE'].includes(provider);

    // pre mobil je s vypnutym profilom fullscreen dovoleny pre vsetkych okrem providerov v poli, so zapnutym pre vsetkych, ktory sa nestazovali na porusovanie podmienok
    if (isProfilePlayerProviderFullscreenEnabled()) {
        return !NOT_FULLSCREEN_COMPLAINING_PROVIDER.includes(provider);
    } else {
        return !['IMG'].includes(provider);
    }
};

export const allowPauseStream = (provider?: NikeStream.Provider | string) => provider !== 'BETCONSTRUCT';
export const disableRemotePlaybackStream = (provider?: NikeStream.Provider | string) => provider !== 'IMG';

// TODO: Zjednotit;
export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
